import { Text, Tooltip } from '@radix-ui/themes';
import { CircleDashed, Clock } from 'lucide-react';
import type { Ref } from 'react';
import { useTranslation } from 'react-i18next';
import { formatRelativeTime } from '../../utils/relativeTime';
import AiDetectionIcon from '../AiDetectionIcon';
import { CandidateName, getScore, getStatus } from '../common';

const ApplicantCard = ({
  application,
  selectCallback,
  threshold,
  columnId,
  jobId,
  index,
  ref,
  selected,
}: {
  application: {
    id: string;
    stage: number;
    score: number;
    status: string;
    accepted: boolean;
    createdAt: string;
    candidate: { id: string; firstName: string; lastName: string };
    aiDetection: { isAi: boolean };
    activityLog: { createdAt: string; actionType: string; actionSubType: string; message: string }[];
  };
  selectCallback: (e: {
    candidateId: string;
    applicationId: string;
    column?: string;
    jobId?: string;
    index?: number;
  }) => void;
  threshold: number;
  columnId?: string;
  jobId?: string;
  index?: number;
  ref?: Ref<HTMLDivElement>;
  selected?: boolean;
}) => {
  const { t } = useTranslation();
  let appliedDate, latestActivityDate;
  if (application) appliedDate = new Date(application.createdAt);
  if (application && application.activityLog && application.activityLog.length > 0) {
    latestActivityDate = new Date(application.activityLog[application.activityLog.length - 1].createdAt);
  }
  const isSelected = selected ?? false;
  return (
    <div
      className={'applicant-list-item shadow-sm pr-2'}
      id={`applicationId-${application.id}`}
      ref={ref}
      style={{ borderWidth: '1px', borderStyle: 'solid', borderColor: isSelected ? 'var(--violet)' : 'var(--white)' }}
      onClick={() =>
        selectCallback({
          candidateId: application.candidate.id,
          applicationId: application.id,
          column: columnId,
          jobId: jobId,
          index: index,
        })
      }
    >
      <div className="score">{getScore({ application: application, threshold: threshold, size: 'list' })}</div>
      <div className="pill-height self-center flex">
        <div>
          <CandidateName application={application} className="name align-top" />
        </div>
        <div className="flex flex-row justify-between status-row">
          <span>{getStatus(application)}</span>

          <div className="mr-2">
            {application && application.aiDetection && application.aiDetection.isAi ? (
              <AiDetectionIcon iconSize={20} tooltipText={t('swiper.applicantCard.aiTooltip')} />
            ) : null}
          </div>
          <Tooltip content={<Text size="3">{`Applied ${appliedDate?.toLocaleString('sv-se')}`}</Text>}>
            <span className="time mr-4 flex flex-row items-center">
              <Clock className="mr-1" size={16} />
              <span className="align-middle">{appliedDate ? formatRelativeTime(appliedDate) : ''}</span>
            </span>
          </Tooltip>
          <Tooltip content={<Text size="3">{`Latest activity ${latestActivityDate?.toLocaleString('sv-se')}`}</Text>}>
            <span className="time flex flex-row items-center">
              <CircleDashed className="mr-1" size={16} />
              <span className="align-middle">{latestActivityDate ? formatRelativeTime(latestActivityDate) : ''}</span>
            </span>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
export default ApplicantCard;
